// Нейтральные приглушённые цвета для аватарок пространств
const AVATAR_COLORS = [
  '#6B7280', // серый
  '#78716C', // камень
  '#71717A', // цинк
  '#737373', // нейтральный
  '#64748B', // сланец
  '#6B7280', // серый (доп.)
  '#78716C', // камень (доп.)
  '#71717A', // цинк (доп.)
  '#737373', // нейтральный (доп.)
  '#64748B', // сланец (доп.)
]

/** Генерация цвета из названия (детерминированный хеш) */
export function getAvatarColor(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length
  return AVATAR_COLORS[index]
}

/** Получить первую букву названия (заглавная) */
export function getAvatarLetter(name: string): string {
  return (name.charAt(0) || '?').toUpperCase()
}

/**
 * Keyword → Lucide icon name mapping.
 * Used as fallback when no category icon is available.
 */
const KEYWORD_ICON_MAP: Array<{ keywords: string[]; icon: string }> = [
  { keywords: ['маркетолог', 'маркетинг', 'реклам', 'smm', 'таргет', 'промо', 'креатив'], icon: 'megaphone' },
  { keywords: ['telegram', 'телеграм', 'бот', 'мессенджер', 'канал'], icon: 'send' },
  { keywords: ['аналитик', 'анализ', 'данные', 'метрик', 'статистик', 'отчёт', 'отчет'], icon: 'bar-chart-2' },
  { keywords: ['аудит', 'cro', 'ux', 'юзабилити', 'конверси'], icon: 'search' },
  { keywords: ['лендинг', 'сайт', 'веб', 'web', 'страниц', 'верстк'], icon: 'layout' },
  { keywords: ['код', 'программ', 'разработ', 'dev', 'code', 'api', 'backend', 'frontend'], icon: 'code' },
  { keywords: ['дизайн', 'design', 'ui', 'интерфейс', 'макет', 'figma'], icon: 'palette' },
  { keywords: ['пис', 'текст', 'копирайт', 'контент', 'статья', 'блог', 'редактор'], icon: 'pen-tool' },
  { keywords: ['юрист', 'юридич', 'право', 'закон', 'договор', 'контракт'], icon: 'scale' },
  { keywords: ['бизнес', 'стратег', 'менеджер', 'управлен', 'планирован'], icon: 'briefcase' },
  { keywords: ['учител', 'преподав', 'обучени', 'курс', 'образован', 'студент'], icon: 'graduation-cap' },
  { keywords: ['здоровь', 'медицин', 'врач', 'доктор', 'фитнес', 'питани'], icon: 'heart' },
  { keywords: ['идея', 'креатив', 'брейнсторм', 'генерац'], icon: 'lightbulb' },
  { keywords: ['перевод', 'язык', 'english', 'лингвист', 'переводчик'], icon: 'globe' },
  { keywords: ['фото', 'видео', 'съёмк', 'камер', 'монтаж', 'продакшн'], icon: 'camera' },
  { keywords: ['музык', 'звук', 'аудио', 'подкаст'], icon: 'music' },
  { keywords: ['книг', 'чтени', 'литератур', 'библиотек'], icon: 'book-open' },
  { keywords: ['безопасност', 'защит', 'секьюрити', 'security'], icon: 'shield' },
  { keywords: ['быстр', 'автоматизац', 'оптимизац', 'скорост', 'производительн'], icon: 'zap' },
  { keywords: ['продаж', 'клиент', 'crm', 'покупател', 'звонк', 'консультац'], icon: 'phone' },
  { keywords: ['email', 'почт', 'рассылк', 'письм'], icon: 'mail' },
  { keywords: ['финанс', 'бухгалтер', 'налог', 'бюджет', 'деньг', 'инвестиц'], icon: 'wallet' },
  { keywords: ['hr', 'кадр', 'персонал', 'найм', 'собеседован', 'рекрутинг'], icon: 'users' },
  { keywords: ['чат', 'общени', 'помощник', 'ассистент', 'диалог'], icon: 'message-circle' },
]

/**
 * Infer icon name from space title (keyword-based).
 * Returns null if no keywords match.
 */
export function inferIconFromTitle(title: string): string | null {
  const lower = title.toLowerCase()
  for (const entry of KEYWORD_ICON_MAP) {
    for (const keyword of entry.keywords) {
      if (lower.includes(keyword)) {
        return entry.icon
      }
    }
  }
  return null
}

/**
 * Get the best icon name for a space.
 * Priority: categoryIcon > title keywords > 'bot' (default)
 */
export function getSpaceIcon(title: string, categoryIcon?: string | null): string {
  if (categoryIcon) return categoryIcon
  return inferIconFromTitle(title) || 'bot'
}
